import React from 'react';

interface MobileIconProps extends React.SVGProps<SVGSVGElement> {}

export const MobileIcon = ({ width = 89, height = 102, ...props }: MobileIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 89 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#filter0_f_272_443)">
      <ellipse cx="34.5" cy="4.5" rx="34.5" ry="4.5" transform="matrix(1 0 0 -1 10 92)" fill="#4444FF"/>
    </g>
    <g filter="url(#filter1_d_272_443)">
      <path d="M44.2818 21.164L27.9683 28.7711C26.8866 29.2755 26.0496 30.1889 25.6414 31.3104C25.2333 32.4319 25.2873 33.6696 25.7917 34.7513L39.7381 64.6594C40.2425 65.7411 41.1559 66.5781 42.2774 66.9862C43.3989 67.3944 44.6366 67.3404 45.7182 66.836L62.0318 59.2289C63.1134 58.7245 63.9504 57.8111 64.3586 56.6896C64.7668 55.5681 64.7128 54.3304 64.2084 53.2487L50.262 23.3406C49.7576 22.2589 48.8442 21.4219 47.7227 21.0137C46.6012 20.6055 45.3635 20.6596 44.2818 21.164ZM61.4895 54.5166C61.6576 54.8771 61.6756 55.2897 61.5395 55.6635C61.4035 56.0374 61.1245 56.3418 60.7639 56.51L44.4504 64.1171C44.0898 64.2852 43.6773 64.3032 43.3034 64.1672C42.9296 64.0311 42.6251 63.7521 42.457 63.3916L28.5106 33.4834C28.3425 33.1228 28.3245 32.7103 28.4605 32.3364C28.5966 31.9626 28.8756 31.6581 29.2361 31.49L45.5497 23.8829C45.9102 23.7148 46.3228 23.6967 46.6966 23.8328C47.0705 23.9689 47.3749 24.2479 47.5431 24.6084L61.4895 54.5166ZM41.6508 31.4937C41.8389 31.897 41.9032 32.347 41.8355 32.7868C41.7678 33.2267 41.5712 33.6365 41.2705 33.9646C40.9699 34.2927 40.5787 34.5243 40.1464 34.6301C39.7142 34.7359 39.2603 34.7111 38.8421 34.5589C38.4239 34.4067 38.0603 34.1339 37.7971 33.775C37.534 33.4161 37.3832 32.9873 37.3638 32.5427C37.3444 32.0981 37.4572 31.6578 37.6881 31.2773C37.919 30.8969 38.2574 30.5934 38.6608 30.4054C39.2016 30.1532 39.8204 30.1262 40.3812 30.3303C40.9419 30.5343 41.3986 30.9528 41.6508 31.4937Z" fill="white"/>
    </g>
    <g opacity="0.3">
      <path d="M69 15C69 17.7614 71.2386 20 74 20C71.2386 20 69 22.2386 69 25C69 22.2386 66.7614 20 64 20C66.7614 20 69 17.7614 69 15Z" fill="white"/>
      <path d="M23 59C23 62.866 26.134 66 30 66C26.134 66 23 69.134 23 73C23 69.134 19.866 66 16 66C19.866 66 23 62.866 23 59Z" fill="white"/>
    </g>
    <defs>
      <filter id="filter0_f_272_443" x="0" y="73" width="89" height="29" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur_272_443"/>
      </filter>
      <filter id="filter1_d_272_443" x="15.3701" y="10.7423" width="59.26" height="66.5153" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0 1 0 0 0 1 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_272_443"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_272_443" result="shape"/>
      </filter>
    </defs>
  </svg>
);

